import { NotFound } from '@/components/pages/Errors/NotFound'
import { Page } from '@/core/architecture'

import { TicketShareSelectTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * TicketShareSelect Page
 * Implemented as a practical sample.
 */
export const TicketShareSelect: Page = () => {
  const { state, actions } = useViewModel()

  if (!state.loading && !state.serial) {
    return <NotFound useNextRouter={false} />
  }

  return <TicketShareSelectTemplate state={state} {...actions} />
}
